export var CORES_COMUNICADOS = {
    1: {
        pure: {
            color: "#3A8BAF",
            textColor: "#FFF"
        },
    },
    2: {
        pure: {
            color: "#2196F3",
            textColor: "#FFF"
        },
    },
    3: {
        pure: {
            color: "#9C27B0",
            textColor: "#fff"
        },
    },
    4: {
        pure: {
            color: "#F44336",
            textColor: "#fff"
        },
    },
    5: {
        pure: {
            color: "#4CAF50",
            textColor: "#fff"
        },
    },
    9: {
        pure: {
            color: "#FF9800",
            textColor: "#000"
        },
    },
    10: {
        pure: {
            color: "#1D7861",
            textColor: "#fff"
        },
    },
    11: {
        pure: {
            color: "#FF5722",
            textColor: "#000"
        },
    },
    14: {
        pure: {
            color: "#3f51b5",
            textColor: "#fff"
        },
    },
    15: {
        pure: {
            color: "#1D7861",
            textColor: "#fff"
        },
    },
    16: {
        pure: {
            color: "#4CAF50",
            textColor: "#fff"
        },
    },
    20: {
        pure: {
            color: "#3A8BAF",
            textColor: "#fff"
        },
    },
};
